import { environment as base } from './environment.base';


export const environment = Object.assign({}, base, {
  /**
   * Name of the environment
   */
  name: 'prod',

  /**
   * Base URL of the AOPA Airports API
   */
  airportsApiUrl: 'https://webapp.aopa.org/AirportsAPI',

  /**
   * Base URL of the authentication server
   */
  authUrl: 'https://authapi.aopa.org/identity',

  /**
   * Base URL of weather API
   */
  weatherApiUrl: 'https://webservice.aopa.org/wx/v2/index.cfm',

  /**
   * Google Maps API key
   */
  googleApiKey: 'AIzaSyDZDcKf_bdy492OuqusX-rrFLGGIgERPeI',

  /**
   * Sitecore travel article API
   */
  // travelArticleApiUrl: 'https://uatwww.aopa.org/api/destinationarticles/articles/?token=47edad27-7857-4546-affc-4832bb03b6a2'
  travelArticleApiUrl: 'https://www.aopa.org/api/destinationarticles/articles/?token=47edad27-7857-4546-affc-4832bb03b6a2',

  flightBridgeHotelUrl: 'https://www.flightbridge.com/Redirect/AdHocHotelSearch?TripSystemIdentifier=4fc660e3-6aee-4f83-93fe-e456107c5fd1',

  flightBridgeAnywhereHotelUrl: 'https://www.flightbridge.com/Redirect/BookNowHotel?TripSystemIdentifier=4fc660e3-6aee-4f83-93fe-e456107c5fd1',

  flightBridgeRentalCarUrl: 'https://www.flightbridge.com/Redirect/AdHocRentalCarSearch?TripSystemIdentifier=4fc660e3-6aee-4f83-93fe-e456107c5fd1',

  flightBridgeAnywhereRentalCarUrl: 'https://www.flightbridge.com/Redirect/BookNowRentalCar?TripSystemIdentifier=4fc660e3-6aee-4f83-93fe-e456107c5fd1',

  flightBridgeAirlineUrl: 'https://www.flightbridge.com/Redirect/BookNowAirline?TripSystemIdentifier=4fc660e3-6aee-4f83-93fe-e456107c5fd1'
});
